import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";

const login = createAsyncThunk(
  "userAuthentication/login",
  async (formData: object, { rejectWithValue }) => {
    try {
      let response = await fetch(`${api.baseURL}user/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
      if (!response.ok) {
        throw response.statusText;
      }
      let { user } = await response.json();
      localStorage.setItem('token', user.token);
      return user;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export default login;
